import { useReducer, useState } from "react";
import { getItems, createItem, updateItem, defaultItem, deleteItem, reducer
} from "./functions";
import { useNotifications } from "../../common/useNotifications";
import { connector } from "../../common/connector";
import { notification } from "antd";

export const useClientes = () => {
    const { showSuccess, showInfo, showError, confirmDelete } = useNotifications();
    const [formVisibility, setFormVisibility] = useState(false);
    const [modalFileVisibility, setModalFileVisibility] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);
    const [file, setFile] = useState(null);

    const [items, dispatch] = useReducer(reducer);
    const [editItem, setEditItem] = useState(defaultItem);
    const [loading, setLoading] = useState(false);
    const [tableParams, setTableParams] = useState({
        pagination: { "current": 1, "pageSize": 10, "total": 0 },
        filters: {},
        sorter: {},
    });

    const fillItems = async (params = tableParams) => {
        try {
            setLoading(true);
            let { data } = await getItems(params);
            let { rows, total, current } = data;

            dispatch({ type: "FILL", payload: rows });
            setTableParams(prev => {
                return {
                    ...prev,
                    ...params,
                    pagination: {
                        ...prev.pagination,
                        ...params.pagination,
                        total: total,
                        current: current
                    }
                }
            });
        } catch (error) { throw new Error(error); }
        finally { setLoading(false); }
    }

    const newItem = () => {
        setEditItem(defaultItem); showForm();
    }

    const handle_save = async (item) => {
        return new Promise(async (resolve, reject) => {
            try {
                if (item === editItem) { showInfo("No hay cambios."); resolve(); return; }
                setLoading(true);
                let item_action = (item.id === 0) ? createItem(item) : updateItem(item);
                let res = await item_action;
                if (item.id === 0) {
                    item.id = res.data.id;
                    fillItems();
                    setEditItem({...item});
                } else { dispatch({ type: "UPDATE", payload: item }); }
                showSuccess("¡Guardado correcto!");
                resolve();
            } catch (e) {
                showError(e.message);
                reject(e);
            } finally { setLoading(false); }
        });
    }

    const selectItem = (item) => {
        setEditItem({...item});
        showForm();
    }

    const handle_delete = async (id) => {
        if(await confirmDelete(id)) {
            await deleteItem(id);
            fillItems();
        }
    }

    const showForm = () => {
        setFormVisibility(true);
    }

    const hideForm = () => {
        setFormVisibility(false);
    }

    const showModalFile = () => {
        setModalFileVisibility(true);
    }

    const hideModalFile = () => {
        setModalFileVisibility(false);
    }

    const setFileParam = (file) => {
        setFile(file);
    }

    const submitUploadFile = (values) => {

        if(!file) { notification.error({
            message: 'No hay ningún archivo seleccionado.'
        }); }

        let formData = new FormData();
        formData.append('massive_file', file);
        try {
            setFileLoading(true);
            let res = connector.post(`/api/upload-massive-file`, formData);
            notification.success({
                message: "'Importación finalizada.'"
            });
            setModalFileVisibility(false);
            fillItems();
        } catch (error) {}
        finally{ setFileLoading(false); }
    }

    const handleTableChange = (pagination, filters, sorter, extra) => {
        let params = {
            ...tableParams,
            pagination,
            filters,
            sorter,
        };
        fillItems(params);
    }

    return {
        items: {
            items,
            editItem,
            selectItem,
            fillItems,
            handle_save,
            handle_delete,
            newItem,
        },
        formParams: {
            showForm,
            hideForm,
            formVisibility
        },
        fileModalParams: {
            showModalFile,
            hideModalFile,
            modalFileVisibility,
            fileLoading,
            setFileParam,
            file,
            submitUploadFile
        },
        loading,
        tableParams,
        handleTableChange
    };

}
